import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";
import config from "../config/config";

export const AppContext = createContext();

const AppContextProvider = ({ children }) => {
  const loginuserid = localStorage.getItem("ID");
  const UserRole = localStorage.getItem("QB");
  console.log(UserRole,"410501");
  const token = localStorage.getItem("Token");
  
  const [getValueString, setGetValueString] = useState();
  const [getdDeleteTableRows, setGetDeleteTableRows] = useState();
  const [fetchBrand, setFetchBrand] = useState();
  const [itemVariations, setItemVariations] = useState();
  const [mailingAddress, setMailingAddress] = useState("");
  const [mailingAdd, setMailingAdd] = useState({
    mail: "",
  });
  const [autoGeneration, setAutoGeneration] = useState();
  const [Label, setLabel] = useState(false);
  const [UserRoles,setUserRole]= useState(UserRole)
  const [ itemdata , setitemdata] = useState([])

  useEffect(() => {
    axios
      .get(
        `${config.quickbooksBaseUrl}/quickbooks/gettoken?loginuserid=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )

      .then((res) => {
        const data = res.data.ResponseData[0];
        if (data.Isconnected == 1) {
          setLabel(true);
        }else {
          setLabel(false)
        }
      })
      .catch((err) => {
        console.log(err);
      });


   
      
  }, []);


  const valueStringFunction = (event) => {
    console.log(getValueString);
    setGetValueString({ ...getValueString, event });
  };

  const deleteTableRowsFunction = (event) => {
    console.log(getValueString);
    setGetDeleteTableRows({ ...getdDeleteTableRows, event });
  };

  const fetchBrandFunction = (event) => {
    console.log(getValueString);
    setFetchBrand({ ...fetchBrand, event });
  };

  const fetchItemVariation = (event) => {
    console.log(getValueString);
    setItemVariations({ ...itemVariations, event });
  };

  const updateMail = (mail) => {
    console.log(mailingAdd, "fffffffffffffffffff");
    setMailingAdd({ mail });
  };

  const autoGenerationFunction = (event) => {
    console.log(mailingAdd, "fffffffffffffffffff");
    setAutoGeneration({ ...autoGeneration, event });
  };


  const userdata = (data) => {
    console.log(data,"410501");
    
  }


  const ItemIds = async  (data) => {
    console.log(data,"5555");


   let res = await axios
    .get(
      `${config.itemsBaseUrl}/items/iteminfofindbyid?id=${data > 0 ? data : 0}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      }
    )

    console.log(res.data.ResponseData,"5555");
    setitemdata(res.data.ResponseData)
    
    
  }

  return (
    <AppContext.Provider
      value={{
        valueStringFunction,
        deleteTableRowsFunction,
        fetchBrandFunction,
        fetchItemVariation,
        updateMail,
        autoGenerationFunction,
        mailingAddress,
        setMailingAddress,
        Label,
        userdata,
        ItemIds,
        itemdata,
        UserRoles
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
